// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fliq","left":"styles_left__2vRbs"};